import React from 'react';
import { cn } from '../../../utils/cn';

export interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {
  /** Text size variant */
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl';
  /** Text color variant */
  color?: 'default' | 'muted' | 'accent' | 'primary';
  /** Font weight */
  weight?: 'normal' | 'medium' | 'semibold';
  /** Line height variant */
  leading?: 'tight' | 'normal' | 'relaxed' | 'loose';
}

const paragraphSizes = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
};

const paragraphColors = {
  default: 'text-neutral-900 dark:text-neutral-100',
  muted: 'text-neutral-600 dark:text-neutral-400',
  accent: 'text-accent-600 dark:text-accent-400',
  primary: 'text-primary-600 dark:text-primary-400',
};

const paragraphWeights = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
};

const paragraphLeading = {
  tight: 'leading-tight',
  normal: 'leading-normal',
  relaxed: 'leading-relaxed',
  loose: 'leading-loose',
};

export const Paragraph = React.forwardRef<HTMLParagraphElement, ParagraphProps>(
  (
    {
      className,
      size = 'base',
      color = 'default',
      weight = 'normal',
      leading = 'relaxed',
      children,
      ...props
    },
    ref
  ) => {
    return (
      <p
        className={cn(
          // Base styles
          'text-pretty',
          // Size
          paragraphSizes[size],
          // Color
          paragraphColors[color],
          // Weight
          paragraphWeights[weight],
          // Leading
          paragraphLeading[leading],
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </p>
    );
  }
);

Paragraph.displayName = 'Paragraph';